import React,{ Component } from "react";
import i18next from "i18next";
import { setGuestPreferedLang } from '../action/homeAction'
import { connect } from 'react-redux';
import {setGuestDeviceLang} from '../action/action';
import {withTranslation} from "react-i18next";
import { sendAnalytics } from "../../action/homeAction"
import { APP_LAYOUT } from "../../config/constant";
import { getDefaultAnalyticsLabel } from "../JS/utility";

class SelectLanguageDropdown extends Component{

    constructor(props){
        super(props);
        this.state = {
            showLangDropdown:false,
            selectedLang:null,
            languageList: []
        }
    }

    selectLangHandler = value => {
        let langCode 
        // switch(value){
        //     case 'English': langCode = 'en';
        //         break;
        //     case 'Spanish': langCode = 'es';
        //         break;
        //     case 'French': langCode = 'fr';
        //         break;
        //     case 'Traditional Chinese': langCode = 'zh_CHT';
        //         break;
        //     case 'Simplified Chinese': langCode = 'zh_CHS';
        //         break;
        // }

        this.props.languagelistData.map( langObj => {
            if(langObj.language == value){
                langCode = langObj.languageCode
                localStorage.setItem('GuestPreferedLangName', langObj.language)
            }
        })

        // Send Analytics
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            this.props.guestDetail, 
            APP_LAYOUT, 
            langCode, 
            {...label, "layoutLanguage": value, "layoutName": localStorage.getItem("LayoutMaster")}, 
            0, 
            this.props.guestIsLoggedIn,
            () => window.location.reload()
        );
        //

        this.props.setGuestPreferedLang(langCode);
        localStorage.setItem('GuestPreferedLang', langCode);
        if(window.FirebasePlugin){
            window.FirebasePlugin.setCrashlyticsCustomKey('GuestSelectedLang', langCode);
        }
        this.setState({showLangDropdown:false})
        this.setState({selectedLang:value})
        i18next.changeLanguage(langCode)
    }

    componentDidMount(){
        
        // this.props.languagelistData.map( langObj => {
        //     if(langObj.languageCode == this.props.guestDeviceLang.slice(0,2)){
        //         setGuestPreferedLang(langObj.languageCode);
        //         localStorage.setItem('GuestPreferedLang', langCode);
        //     }
        // })
    }//class="form-row margin-top-1 align-left"

    render(){
        let language = localStorage.getItem('GuestPreferedLangName');
        const { t } = this.props;   
        return(
            < >
                <label>{t('profile.prefered_lang_lbl')}:</label>
                <div class="custom-select">
                    <div className={`select-selected ${this.state.showLangDropdown ? "select-arrow-active" : ""}`} onClick = {() => this.state.showLangDropdown == false ? this.setState({showLangDropdown: true}): this.setState({showLangDropdown: false})}>
                        {language ? language : "Please select"}
                    </div>
                    <div className={`select-items ${this.state.showLangDropdown ? "" : "select-hide"}`}>{/*["English","French","Simplified Chinese","Traditional Chinese","Spanish"] */}
                        {this.props.languageList.map(el=> (
                            <div key={el} onClick={() => this.selectLangHandler(el)}>{el}</div>
                        ))}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        guestPreferedLang: state.store2.guestPreferedLang,
        languageCodeList: state.store.home.languageCodeList,
        languageList: state.store.home.languageList,
        languagelistData: state.store.home.languagelistData,
        guestDeviceLang: state.store2.guestDeviceLang,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(
    mapStateToProps,
    {
        setGuestDeviceLang,
        setGuestPreferedLang,
        sendAnalytics
    }
)(withTranslation('translations')(SelectLanguageDropdown));